export default __webpack_public_path__ + "static/media/351.e03754de.png";